// Item pictures (data URLs) rendered at start-up by three/thumbnails.ts.
// Kept here, outside the 3D code, so the shop and locker can show them
// without loading three.js.
const thumbs = new Map<string, string>();

/** The picture of an item, or null (not a hat/robe, or not rendered). */
export function itemThumb(id: string): string | null {
  return thumbs.get(id) ?? null;
}

export function setItemThumb(id: string, url: string): void {
  thumbs.set(id, url);
}
